export enum LanguageIds {
    ALL=0,
    EN=1,
    DE=2,
    FR=3,
    IT=4,
    ES=5,
    NL=6,
    TR=7,
    PY=8,
    PT=9
}
/*

English
Deutsch
Français
Italiano
Español
Nederlands
Türkçe
Русский
Português
*/
